{
  "chassisPositions": [
    {
      "mainSegment": "Industrial",
      "installationTypes": ["Electromobility", "Versatile"],
      "drivelinePositions": []
    },
    {
      "mainSegment": "Marine",
      "installationTypes": ["MechanicalPropulsion"],
      "drivelinePositions": [
        {
          "drivelineCount": 1,
          "positions": [
            {
              "position": 1,
              "chassisPositionName": "DRIVELINE_CENTER",
              "drivelinePositionName": "CENTER",
              "chassisPositionDisplayName": "Center Driveline",
              "drivelinePositionDisplayName": "Center"
            }
          ]
        },
        {
          "drivelineCount": 2,
          "positions": [
            {
              "position": 1,
              "chassisPositionName": "DRIVELINE_PORT",
              "drivelinePositionName": "PORT",
              "chassisPositionDisplayName": "Port Driveline",
              "drivelinePositionDisplayName": "Port"
            },
            {
              "position": 2,
              "chassisPositionName": "DRIVELINE_STARBOARD",
              "drivelinePositionName": "STARBOARD",
              "chassisPositionDisplayName": "Starboard Driveline",
              "drivelinePositionDisplayName": "Starboard"
            }
          ]
        },
        {
          "drivelineCount": 3,
          "positions": [
            {
              "position": 1,
              "chassisPositionName": "DRIVELINE_PORT",
              "drivelinePositionName": "PORT",
              "chassisPositionDisplayName": "Port Driveline",
              "drivelinePositionDisplayName": "Port"
            },
            {
              "position": 2,
              "chassisPositionName": "DRIVELINE_CENTER",
              "drivelinePositionName": "CENTER",
              "chassisPositionDisplayName": "Center Driveline",
              "drivelinePositionDisplayName": "Center"
            },
            {
              "position": 3,
              "chassisPositionName": "DRIVELINE_STARBOARD",
              "drivelinePositionName": "STARBOARD",
              "chassisPositionDisplayName": "Starboard Driveline",
              "drivelinePositionDisplayName": "Starboard"
            }
          ]
        },
        {
          "drivelineCount": 4,
          "positions": [
            {
              "position": 1,
              "chassisPositionName": "DRIVELINE_PORT",
              "drivelinePositionName": "PORT",
              "chassisPositionDisplayName": "Port Driveline",
              "drivelinePositionDisplayName": "Port"
            },
            {
              "position": 2,
              "chassisPositionName": "DRIVELINE_CENTER_PORT",
              "drivelinePositionName": "CENTER_PORT",
              "chassisPositionDisplayName": "Port Center Driveline",
              "drivelinePositionDisplayName": "Port Center"
            },
            {
              "position": 3,
              "chassisPositionName": "DRIVELINE_CENTER_STARBOARD",
              "drivelinePositionName": "CENTER_STARBOARD",
              "chassisPositionDisplayName": "Starboard Center Driveline",
              "drivelinePositionDisplayName": "Starboard Center"
            },
            {
              "position": 4,
              "chassisPositionName": "DRIVELINE_STARBOARD",
              "drivelinePositionName": "STARBOARD",
              "chassisPositionDisplayName": "Starboard Driveline",
              "drivelinePositionDisplayName": "Starboard"
            }
          ]
        },
        {
          "drivelineCount": 6,
          "positions": [
            {
              "position": 1,
              "chassisPositionName": "ENGINE_PORT_FRONT",
              "drivelinePositionName": "PORT",
              "chassisPositionDisplayName": "Port Front Engine",
              "drivelinePositionDisplayName": "Port"
            },
            {
              "position": 2,
              "chassisPositionName": "DRIVE_PORT",
              "drivelinePositionName": "PORT",
              "chassisPositionDisplayName": "Port Drive",
              "drivelinePositionDisplayName": "Port"
            },
            {
              "position": 3,
              "chassisPositionName": "ENGINE_PORT_REAR",
              "drivelinePositionName": "PORT",
              "chassisPositionDisplayName": "Port Rear Engine",
              "drivelinePositionDisplayName": "Port"
            },
            {
              "position": 4,
              "chassisPositionName": "ENGINE_STARBOARD_FRONT",
              "drivelinePositionName": "STARBOARD",
              "chassisPositionDisplayName": "Starboard Front Engine",
              "drivelinePositionDisplayName": "Starboard"
            },
            {
              "position": 5,
              "chassisPositionName": "DRIVE_STARBOARD",
              "drivelinePositionName": "STARBOARD",
              "chassisPositionDisplayName": "Starboard Drive",
              "drivelinePositionDisplayName": "Starboard"
            },
            {
              "position": 6,
              "chassisPositionName": "ENGINE_STARBOARD_REAR",
              "drivelinePositionName": "STARBOARD",
              "chassisPositionDisplayName": "Starboard Rear Engine",
              "drivelinePositionDisplayName": "Starboard"
            }
          ]
        },
        {
          "drivelineCount": 9,
          "positions": [
            {
              "position": 1,
              "chassisPositionName": "ENGINE_PORT_FRONT",
              "drivelinePositionName": "PORT",
              "chassisPositionDisplayName": "Port Front Engine",
              "drivelinePositionDisplayName": "Port"
            },
            {
              "position": 2,
              "chassisPositionName": "DRIVE_PORT",
              "drivelinePositionName": "PORT",
              "chassisPositionDisplayName": "Port Drive",
              "drivelinePositionDisplayName": "Port"
            },
            {
              "position": 3,
              "chassisPositionName": "ENGINE_PORT_REAR",
              "drivelinePositionName": "PORT",
              "chassisPositionDisplayName": "Port Rear Engine",
              "drivelinePositionDisplayName": "Port"
            },
            {
              "position": 4,
              "chassisPositionName": "ENGINE_CENTER_PORT_FRONT",
              "drivelinePositionName": "CENTER_PORT",
              "chassisPositionDisplayName": "Center Front Engine",
              "drivelinePositionDisplayName": "Center"
            },
            {
              "position": 5,
              "chassisPositionName": "DRIVE_CENTER_PORT",
              "drivelinePositionName": "CENTER_PORT",
              "chassisPositionDisplayName": "Center Drive",
              "drivelinePositionDisplayName": "Center"
            },
            {
              "position": 6,
              "chassisPositionName": "ENGINE_CENTER_PORT_REAR",
              "drivelinePositionName": "CENTER_PORT",
              "chassisPositionDisplayName": "Center Rear Engine",
              "drivelinePositionDisplayName": "Center"
            },
            {
              "position": 7,
              "chassisPositionName": "ENGINE_STARBOARD_FRONT",
              "drivelinePositionName": "STARBOARD",
              "chassisPositionDisplayName": "Starboard Front Engine",
              "drivelinePositionDisplayName": "Starboard"
            },
            {
              "position": 8,
              "chassisPositionName": "DRIVE_STARBOARD",
              "drivelinePositionName": "STARBOARD",
              "chassisPositionDisplayName": "Starboard Drive",
              "drivelinePositionDisplayName": "Starboard"
            },
            {
              "position": 9,
              "chassisPositionName": "ENGINE_STARBOARD_REAR",
              "drivelinePositionName": "STARBOARD",
              "chassisPositionDisplayName": "Starboard Rear Engine",
              "drivelinePositionDisplayName": "Starboard"
            }
          ]
        },
        {
          "drivelineCount": 12,
          "positions": [
            {
              "position": 1,
              "chassisPositionName": "ENGINE_PORT_FRONT",
              "drivelinePositionName": "PORT",
              "chassisPositionDisplayName": "Port Front Engine",
              "drivelinePositionDisplayName": "Port"
            },
            {
              "position": 2,
              "chassisPositionName": "DRIVE_PORT",
              "drivelinePositionName": "PORT",
              "chassisPositionDisplayName": "Port Drive",
              "drivelinePositionDisplayName": "Port"
            },
            {
              "position": 3,
              "chassisPositionName": "ENGINE_PORT_REAR",
              "drivelinePositionName": "PORT",
              "chassisPositionDisplayName": "Port Rear Engine",
              "drivelinePositionDisplayName": "Port"
            },
            {
              "position": 4,
              "chassisPositionName": "ENGINE_CENTER_PORT_FRONT",
              "drivelinePositionName": "CENTER_PORT",
              "chassisPositionDisplayName": "Port Center Front Engine",
              "drivelinePositionDisplayName": "Port Center"
            },
            {
              "position": 5,
              "chassisPositionName": "DRIVE_CENTER_PORT",
              "drivelinePositionName": "CENTER_PORT",
              "chassisPositionDisplayName": "Port Center Drive",
              "drivelinePositionDisplayName": "Port Center"
            },
            {
              "position": 6,
              "chassisPositionName": "ENGINE_CENTER_PORT_REAR",
              "drivelinePositionName": "CENTER_PORT",
              "chassisPositionDisplayName": "Port Center Rear Engine",
              "drivelinePositionDisplayName": "Port Center"
            },
            {
              "position": 7,
              "chassisPositionName": "ENGINE_CENTER_STARBOARD_FRONT",
              "drivelinePositionName": "CENTER_STARBOARD",
              "chassisPositionDisplayName": "Starboard Center Front Engine",
              "drivelinePositionDisplayName": "Starboard Center"
            },
            {
              "position": 8,
              "chassisPositionName": "DRIVE_CENTER_STARBOARD",
              "drivelinePositionName": "CENTER_STARBOARD",
              "chassisPositionDisplayName": "Starboard Center Drive",
              "drivelinePositionDisplayName": "Starboard Center"
            },
            {
              "position": 9,
              "chassisPositionName": "ENGINE_CENTER_STARBOARD_REAR",
              "drivelinePositionName": "CENTER_STARBOARD",
              "chassisPositionDisplayName": "Starboard Center Rear Engine",
              "drivelinePositionDisplayName": "Starboard Center"
            },
            {
              "position": 10,
              "chassisPositionName": "ENGINE_STARBOARD_FRONT",
              "drivelinePositionName": "STARBOARD",
              "chassisPositionDisplayName": "Starboard Front Engine",
              "drivelinePositionDisplayName": "Starboard"
            },
            {
              "position": 11,
              "chassisPositionName": "DRIVE_STARBOARD",
              "drivelinePositionName": "STARBOARD",
              "chassisPositionDisplayName": "Starboard Drive",
              "drivelinePositionDisplayName": "Starboard"
            },
            {
              "position": 12,
              "chassisPositionName": "ENGINE_STARBOARD_REAR",
              "drivelinePositionName": "STARBOARD",
              "chassisPositionDisplayName": "Starboard Rear Engine",
              "drivelinePositionDisplayName": "Starboard"
            }
          ]
        }
      ]
    },
    {
      "mainSegment": "Marine",
      "installationTypes": ["ControlSystem"],
      "drivelinePositions": [
        {
          "drivelineCount": 1,
          "positions": [
            {
              "position": 0,
              "chassisPositionName": "CONTROL",
              "chassisPositionDisplayName": "Main Control System"
            }
          ]
        }
      ]
    }
  ]
}
